import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { SpriteConstant } from 'src/app/constant/sprite.constant';

@Component({
    selector: 'app-alertlivedealernoseatavailable',
    templateUrl: './alertlivedealernoseatavailable.layout.mobile.component.html',
    styleUrls: [
        '../css/alertlivedealernoseatavailable.layout.mobile.component.scss',
    ],
    standalone: false
})
export class alertLiveDealerNoSeatAvailableComponent {
  @Input() alertData: any;
  @Output() eventEmit: EventEmitter<any> = new EventEmitter<any>();
  menu_icons: any;
  LDSeatsObj: any;
  popUpTo: any;
  currentLanguage: any = 'en';
  version = '';
  constructor() {
    this.menu_icons = SpriteConstant.MENU_ICONS;
  }

  @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(
    event: KeyboardEvent
  ) {
    this.onCloseClick();
  }

  onCloseClick = (event = null) => {
    let objClick: any = {};
    objClick.status = 'close';
    this.eventEmit.emit(objClick);
  };
  onRedirectClick = (LDSeatsObj) => {
    if (this.popUpTo == 'cardShuffling') {
      let objClick: any = {};
      objClick.status = 'redirect';
      objClick.popUpTo = this.popUpTo;
      this.eventEmit.emit(objClick);
    }
    if (LDSeatsObj) {
      let objClick: any = {};
      objClick.status = 'redirect';
      objClick.LDSeatsObj = LDSeatsObj;
      this.eventEmit.emit(objClick);
    }
  };
  onAlertImageClick = (event = null) => {
    //console.log('onAlertImageClick');
    /* this.eventEmit.emit(this.data.iconStr); */
  };

  ngOnInit() {
    if (this.alertData && this.alertData.currentLanguage) {
      this.currentLanguage = this.alertData.currentLanguage;
      //console.log("alertLiveDealerNoSeatAvailableComponent..",this.currentLanguage)
    }
    if (this.alertData.LDSeatsObj) {
      this.LDSeatsObj = this.alertData.LDSeatsObj;
    }
    if (this.alertData.popUpTo) {
      this.popUpTo = this.alertData.popUpTo;
    }
  }
  ngOnDestroy() {
    delete this.alertData;
    delete this.menu_icons;
    delete this.LDSeatsObj;
    delete this.currentLanguage;
    delete this.version;
  }
}
